module.exports = __webpack_public_path__ + "img/f5885bd7138e5cdb347ab0a2420e76f3.png";